export function autoSizeTextarea(textarea) {
    if (textarea && textarea.style) {
        textarea.style.height = '16px';
        textarea.style.height = (textarea.scrollHeight) + "px";
        textarea.style.overflowY = "hidden";
    }
}

export function avoidLineBreaks(e) {
    if (e instanceof KeyboardEvent && e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        return;
    }
}
